<template>
  <div>
    <b-container>
      <little-bar
        :current="current"
        :navlist="navlist"
        copyright="forum"
        @changeCurrent="changeCurrent"
      >
        <template v-slot:right-nav>
          <div class="right">
            <div class="term-btn">
              <div class="text">
                <div>期： {{ cyclesel }}</div>
                <b-icon class="arrow" icon="chevron-down"></b-icon>
              </div>
              <div class="drop-down">
                <div
                  class="drop-item"
                  v-for="(value, index) in cycledata"
                  :key="index"
                  @click="cyclesel = value"
                >
                  {{ value }}
                </div>
              </div>
            </div>
            <div class="term-btn">
              <div class="text">
                <div>年份：{{ yearsel }}</div>
                <b-icon class="arrow" icon="chevron-down"></b-icon>
              </div>
              <div class="drop-down">
                <div
                  class="drop-item"
                  v-for="(value, index) in yeardata"
                  :key="index"
                  @click="yearsel = value"
                >
                  {{ value }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </little-bar>
      <keep-alive>
        <router-view />
      </keep-alive>
    </b-container>
  </div>
</template>
<script>
import littleBar from "@/forumcomponents/littleBar";
export default {
  components: {
    littleBar,
  },
  data() {
    return {
      current: 0,
      currentName: "",
      cyclesel: "ALL",
      yearsel: "ALL", //选中菜单
      navlist: [],
      dateDrop: [],
      yeardata: [], //下拉菜单
      cycledata: [],
      type: "", //副导航的活动类型
      index: "", //副导航的次序
    };
  },
  created() {
    this.current = this.$route.query.index;
  },
  mounted() {
    this.getActivityCategory();
    this.getDrop();
  },
  watch: {
    $route: {
      handler(to) {
        this.current = to.query.index;
        this.type = to.query.type;
        this.index = to.query.index;
      },
      immediate: true,
      deep: true,
    },
    cyclesel(val) {
      this.drapSel();
    },
    yearsel(val) {
      this.drapSel();
    },
  },
  methods: {
    showDropDown() {
      this.show = !this.show;
    },
    drapSel() {
      this.$router.push({
        //期的下拉菜单
        path: "/forum/project/list",
        query: {
          index: this.index,
          type: this.type,
          year: this.yearsel == "ALL" ? "" : this.yearsel,
          cycle: this.cyclesel == "ALL" ? "" : this.cyclesel,
        },
      });
    },
    changeCurrent(index, path) {
      //副导航跳转
      this.current = index;
      let typeId = "";
      this.navlist.forEach((item, index) => {
        if (index == this.current) {
          typeId = item.id;
        }
      });
      this.$router.push({
        path: path,
        query: {
          index: index,
          type: typeId,
        },
      });
    },
    getActivityCategory() {
      //获取小导航
      this.$forumApi.activityCategory().then((res) => {
        // console.log("获取小导航---------", res.data);
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].type) {
            continue;
          }
          this.navlist.push({
            text: res.data[i].name,
            id: res.data[i].id,
          });
        }
      });
    },
    getDrop() {
      //获取下拉菜单
      for (let i = 1; i <= 15; i++) {
        // let cycle=
        this.cycledata.push("第" + i + "期");
      }
      this.cycledata.unshift("ALL");

      var nowDate = new Date();
      let isyear = nowDate.getFullYear();
      //计算获取最近六年
      for (let index = 1; index <= 8; index++) {
        this.yeardata.push(isyear - 8 + index);
      }
      this.yeardata.reverse();
      this.yeardata.unshift("ALL");
    },
  },
};
</script>
<style lang="scss" scoped>
.term-btn {
  margin-left: 1rem;
  cursor: pointer;
  color: #000;
  .text {
    display: flex;
    align-items: center;
    width: 8rem;
  }
  .drop-item {
    height: 2.5rem;
    color: #666666;
  }
  .drop-down {
    display: none;
    height: 17rem;
  }
}

.term-btn:hover {
  .drop-down {
    position: relative;
    display: block;
    background-color: #f2f2f2;
    z-index: 99;
    text-align: center;

    .drop-item:hover {
      color: $forum-theme-blue;
      cursor: pointer;
    }
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
  .block {
    padding: 0px 20px;
  }
}

@media (max-width: 768px) {
  .term-btn::v-deep {
    .text {
      justify-content: center;
    }
    .arrow {
      font-size: 20px;
      padding: 6px;
    }
  }
}
</style>